/**
 * Active-tab re-tap: the ONE definition of "scrolled down" (glide to top) vs
 * "at top" (shared refresh). AppShell decides with it and the tab buttons
 * read it to know which narration to play on the icon.
 */
export const RETAP_GLIDE_THRESHOLD_PX = 40;

export function isMainScrolledForRetap(el) {
  const main = el !== undefined ? el
    : (typeof document !== 'undefined' ? document.querySelector('[data-cvx-main-scroll]') : null);
  return !!main && main.scrollTop > RETAP_GLIDE_THRESHOLD_PX;
}
